module.exports = __webpack_public_path__ + "static/amazon-4-4da4516da4fde3aad9ca0d57fef02e60.png";